import { ReporteEquilibrioKRService } from './../../services/reporte-equilibrio-kr.service';
import { ReporteResumenObraService } from './../../services/reporte-resumen-obra.service';
import { AutenticacionService, ModulosARK, TipoPermiso } from './../../services/autenticacion.service';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import { ReportesService } from './../../services/reportes.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {ObrasService} from "../../services/obras.service";
import { DetallesKRModalComponent } from './detalles-kr-modal/detalles-kr-modal.component';


@Component({
  selector: 'app-reporte-equilibrio-kr',
  templateUrl: './reporte-equilibrio-kr.component.html',
  styleUrls: ['./reporte-equilibrio-kr.component.scss']
})
export class ReporteEquilibrioKRComponent implements OnInit {
  @ViewChild(DetallesKRModalComponent) detallesKRModal: DetallesKRModalComponent;
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;

  public obra_filter: any;
  public obra_options: any[];

  public reportes_lista: any[] = [];
  public reporte_actual: any;
  public fecha_actual: any;
  public fecha_inicial_filter: any;
  public fecha_final_filter: any;
  public fecha_creacion: any;
  public fechas_reporte_selected: any = {};
  public totales_reporte_selected: any = {};
  public equilibrio_years_data: any[] = [];
  public resultados_data: any = {};
  public concepto_filter: any;
  public concepto_options: any[];
  public securityActived: any = false;
  public loading_report: any = true;
  public show_report: any = false;
  public not_report: any = false;
  public printing: boolean = false;
  public report_request: any;
  private chart_ready_pending: boolean = false;
  private loader_fallback_timeout: any;
  private obras_loaded: boolean = false;
  private fecha_loaded: boolean = false;
  constructor(private obrasService: ObrasService,
              private reportesService: ReportesService,
              private reporteResumenObraService: ReporteResumenObraService,
              private reporteEquilibrioKRService: ReporteEquilibrioKRService,
              private helperService: HelpersService,
              private router: Router,
              private activedRoute: ActivatedRoute, 
              private helpersService: HelpersService,
              private sanitizer: DomSanitizer, 
              private authService: AutenticacionService) {
  }

  getLiquidaciones(){
    
  }

  ngOnInit() {
    this.start();
  }

  start() {
    this.getObras();
    let reportes_lista = this.reportesService.getListaReportes();
    for (let i = 0; i < reportes_lista.length; i++) {  
      if(reportes_lista[i]["id"] == 1 && this.authService.tienenPermisos(ModulosARK.ReportePorInversionista, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 2 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 3 && this.authService.tienenPermisos(ModulosARK.ReportePorObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 4 && this.authService.tienenPermisos(ModulosARK.ReporteBalanceKr, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 5 && this.authService.tienenPermisos(ModulosARK.ReportePuntoDeEquilibrio, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
        this.reporte_actual = reportes_lista[i]; //reporte equilibrio kr
      }
      if(reportes_lista[i]["id"] == 6 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeDiferencia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 7 && this.authService.tienenPermisos(ModulosARK.ReporteSaldos, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 8 && this.authService.tienenPermisos(ModulosARK.ReporteDepositoGarantia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 9 && this.authService.tienenPermisos(ModulosARK.ReporteCobranza, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
    }    
    this.getFechaActual();
  }

  changeObraFilter(obra) {
    this.obra_filter = obra;
    this.getReporte();
  }

  getObras() {
    this.reporteResumenObraService.getObras().subscribe(response => {

      var obras = [];
      response.json().content.forEach((element, key) => {
        if(element.idObras== 13 ||
         element.idObras== 17 ||
         element.idObras== 1 ) {
          obras.push(element);
        }
      });

      //Agrego una opción para el reporte general
      obras.push({ idObras: 0, nombreObra: 'RESUMEN DEL GRUPO'});

      this.obra_options = obras;
      if (this.obra_options.length > 0) {
        this.obra_filter = this.obra_options[0];
      }
      this.obras_loaded = true;
      this.tryStartReporte();
    }, error => {
      this.helperService.httpGlobalError(error, true);
    });
  }

  // Dispara getReporte una sola vez cuando ambas precondiciones (obras + fecha) estan listas
  tryStartReporte() {
    if (this.obras_loaded && this.fecha_loaded) {
      this.getReporte();
    }
  }

  changeReporte(reporte) {
    if (reporte.id && reporte.id != this.reporte_actual.id) {
      this.router.navigate([reporte.ruta]);
    }
  }

  getFechaActual() {
    this.reportesService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          this.fecha_actual = content.fecha;
          this.fecha_inicial_filter = content.fechaInicio;
          this.fecha_final_filter = this.fecha_actual;
          this.fecha_loaded = true;
          this.tryStartReporte();
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);
          this.loading_report = false;
          this.show_report = false;
          this.not_report = true;
          if (error == 400) {
          }
        });
  }

  changeFilterFechaFinal(fecha) {
    this.fecha_final_filter = fecha;
    // El reporte es anual: la fecha inicial siempre es 1-ene del año del corte
    const anio = (typeof fecha === 'string' ? fecha.substring(0, 4) : new Date(fecha).getFullYear());
    this.fecha_inicial_filter = `${anio}-01-01`;
    this.loading_report = true;
    setTimeout(() => {
      this.getReporte();
    }, 200);
  }

  getReporte() {
    this.loading_report = true;
    this.show_report = false;
    this.chart_ready_pending = true;
    if (this.report_request) {
      this.report_request.unsubscribe();
    }
    if (this.loader_fallback_timeout) {
      clearTimeout(this.loader_fallback_timeout);
    }
    this.report_request = this.reporteEquilibrioKRService.getReporte(this.fecha_inicial_filter, this.fecha_final_filter,
      (this.obra_filter ? this.obra_filter.idObras : 0))
      .subscribe(response => {
        const content_response = response.json().content;
        this.fechas_reporte_selected = content_response.fechas;
        this.totales_reporte_selected = content_response.informacion;
        this.fecha_creacion = content_response.fechaCreacion;
        this.resultados_data = content_response.resultadosMes;
        this.equilibrio_years_data = content_response.puntoEquilibrio;
        this.show_report = true;
        this.not_report = false;
        // El loader se baja cuando el chart termina de pintar (chartReady).
        // Fallback: si por alguna razon chartReady no llega en 2.5s, lo bajamos igual.
        this.loader_fallback_timeout = setTimeout(() => {
          if (this.loading_report) {
            this.loading_report = false;
            this.chart_ready_pending = false;
          }
        }, 2500);
      }, error => {
        // resuelve errores 403, 500 y sin conexión.
        this.helpersService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
        this.chart_ready_pending = false;
      });
  }

  onChartReady() {
    if (this.chart_ready_pending) {
      this.chart_ready_pending = false;
      this.loading_report = false;
      if (this.loader_fallback_timeout) {
        clearTimeout(this.loader_fallback_timeout);
        this.loader_fallback_timeout = null;
      }
    }
  }

  // SEGURITY MODULE
  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.getReporte();
            this.securityActived = false;
            this.securityModal.push({
            'passwordActivated': false
          });
          }
        });
    }
  
  }

  canSecurity() {
    return this.reportesService.canSecurity();
  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.reportesService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if(respuesta.success === true) {
          this.getReporte();
          this.securityModal.push({
            'passwordActivated': true
          });
          this.securityModal.close();
          this.securityActived = true;
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
        this.securityModal.push({
          'passwordActivated': false
        });
      })
  }

  openModalConcepto(idConceptos, mes, anio, $tipoMovimiento) {
    var fechaInicial = this.formatDate(new Date(anio, mes, 1));
    var fechaFinal = this.formatDate(new Date(anio, mes+1, 0));

    this.detallesKRModal.open({
      'idObras': this.obra_filter.idObras,
      'idConceptos': idConceptos,
      'fechaInicial': fechaInicial,
      'fechaFinal': fechaFinal
    });
  }

  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      this.printing = false;
    };
  }
  return() {
    this.router.navigate(['/catalogo-reportes']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-equilibrio-kr/reporte-equilibrio-kr.component.ts